import React from 'react';
import { PharmacyItemsTable } from '../common';
import { PharmacyItem as FormPharmacyItem, PackageDetail } from '../newPharmacyForm.helper';

interface ItemsListProps {
  items: FormPharmacyItem[];
  onSelectChange: (index: number) => void;
  onRemoveItem: (index: number) => void;
  onFieldChange: (index: number, field: keyof FormPharmacyItem, value: string | number) => void;
  onItemUpdate?: (index: number, updates: Partial<FormPharmacyItem>) => void;
  errors?: Array<Record<string, string>>;
  touched?: Array<Record<string, boolean>>;
  disabled?: boolean;
  invoiceStatus?: string;
  packageId?: string | null; // Form-level package selection
  onPackageChange?: (index: number, packageDetail: PackageDetail | null) => void;
}

/**
 * ItemsList - Displays current pharmacy items for billing
 * Uses the common PharmacyItemsTable with full billing columns enabled
 */
const ItemsList: React.FC<ItemsListProps> = ({
  items,
  onSelectChange,
  onRemoveItem,
  onFieldChange,
  onItemUpdate,
  errors = [],
  touched = [],
  disabled = false,
  invoiceStatus = '',
  packageId = null,
  onPackageChange,
}) => {
  return (
    <PharmacyItemsTable
      items={items}
      onSelectChange={onSelectChange}
      onRemoveItem={onRemoveItem}
      onFieldChange={onFieldChange}
      onItemUpdate={onItemUpdate}
      errors={errors}
      touched={touched}
      showBillingColumns={true}
      showDeleteAction={true}
      readOnly={disabled}
      invoiceStatus={invoiceStatus}
      formPackageId={packageId}
      onPackageChange={onPackageChange}
    />
  );
};

export default ItemsList;
